import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcodejs2';

const QRCodeComponent = ({
  text,
  displaySize = 128,
  downloadSize = 512,
}) => {
  const qrRef = useRef(null);

  useEffect(() => {
    if (qrRef.current) {
      qrRef.current.innerHTML = '';

      new QRCode(qrRef.current, {
        text: text,
        width: displaySize,
        height: displaySize,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H,
      });
    }
  }, [text, displaySize]);

  const downloadQRCode = () => {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);

    new QRCode(tempDiv, {
      text: text,
      width: downloadSize,
      height: downloadSize,
      colorDark: '#000',
      colorLight: '#fff',
      correctLevel: QRCode.CorrectLevel.H,
    });

    // Wait briefly to allow canvas generation
    setTimeout(() => {
      const canvas = tempDiv.querySelector('canvas');
      if (canvas) {
        const url = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = url;
        link.download = 'qrcode.png';
        link.click();
      }
      document.body.removeChild(tempDiv);
    }, 100);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

      {/* 👇 Display the actual URL */}
      <div style={{ marginTop: '1rem', wordBreak: 'break-word' }}>
        <strong>QR Code zu Deinen Produkten:</strong>{' '}
        <a href={text} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
        <br />
      </div>
      <div ref={qrRef} />
      <button
        onClick={downloadQRCode}
        style={{
          marginTop: '12px',
          padding: '8px 16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
        }}
      >
        Download als PNG
      </button>


    </div>
  );
};

export default QRCodeComponent;
